import { useAdminCenterTimeFilter } from '../../../utils/hooks';

export const useTimeFilters = () => {
  const { startDate, endDate, selectedTimeFrame, setTimeFilter } = useAdminCenterTimeFilter();

  const handleTimeFilterChange = (newStartDate: Date, newEndDate: Date, timeFrame?: string) => {
    setTimeFilter(newStartDate, newEndDate, timeFrame);
  };

  return {
    startDate,
    endDate,
    selectedTimeFrame,
    handleTimeFilterChange,
  };
};
